/**
 * @file serviceMixin
 * @author fuqiang15
 */

import {get} from 'lodash';
import PageTypeMixin from './pageType';

export default {
    created() {
        if (this.isCreate && this.store.requestAppList) {
            this.store.requestAppList();
        }
    },
    mixins: [PageTypeMixin],
    computed: {
        isEditDraft() {
            return this.isEdit && this.isDraft;
        },
        isDraft() {
            return get(this.store.serviceDetail, 'status') === 'DRAFT'
                || get(this.store.serviceDetail, 'serviceStatus') === 'DRAFT';
        },
        authKey() {
            return get(this.store.serviceDetail, 'serviceData.authKey');
        },
        activityId() {
            return get(this.store.serviceDetail, 'serviceData.activityId');
        },
        cancelText() {
            return this.isDetail ? '返回' : '取消';
        }
    },
    methods: {
        goToCreateApp() {
            this.global.redirect({url: '/app/create', type: 'push'});
        },
        goToServiceList() {
            if (this.store.isAdmin) {
                return this.global.redirect({url: '/service/all/list', type: 'push'});
            }
            let appId = this.store.getRouteParams().appId || this.store.getRouteQuery().appId;
            appId = appId ? `${appId}/` : '';
            this.global.redirect({url: `/app/${appId}service/list`, type: 'push'});
        }
    }
};
